import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", { class: "max-w-[95vw] sm:max-w-[754px] xl:max-w-[1240px] w-full mx-auto mb-10 min-h-screen" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "about",
    class: "flex justify-center items-center"
  }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "lg:text-7xl text-4xl font-black text-center mt-12 ojuju text-[#163537]" }, " About Leo ")
  ]),
  /*#__PURE__*/_createElementVNode("h1", { class: "mt-6" }, "About page 10% loading ...")
], -1)

import AppNavbar from "@/components/AppNavbar.vue";
import AppFooter from "@/components/AppFooter.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AppNavbar),
    _hoisted_1,
    _createVNode(AppFooter)
  ]))
}
}

})